import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  standalone: false,
  
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {

}
